import { Typography } from '@mui/material'

import useChapter from './useChapter'
import styles from './Chapter.module.scss'
import { Copy, CopyContainer } from '../common/copy'

const Chapter = () => {
  const { chapterId, caseComplete } = useChapter()

  return (
    <div className={styles.chapterRoot}>
      <CopyContainer
        padding={{ top: 'xsmall', right: 'xsmall', bottom: 'small' }}
      >
        <Copy>
          <Typography variant="h6" className="text-align-right">
            {caseComplete ? <>Case Complete</> : chapterId}
          </Typography>
        </Copy>
      </CopyContainer>
    </div>
  )
}

export default Chapter
